<template>
    <div>
        <p>
            <a-icon type="clock-circle" theme="filled" />
            You can order from {{ fromTime }} to {{ toTime }}!
        </p>
    </div>
</template>

<script>
export default {
    name: 'OpeningTimeNotificationCard',

    props : {
        fromTime : { type: String },
        toTime : { type : String }

    }
}
</script>

